<template>
  <div>
    <div v-if="faces" class="mgb-40px level">
      <div class="level-left is-flex-direction-column is-align-items-flex-start">
        <p class="is-size-4  has-text-weight-semibold has-text-default">
            {{$t('cartographie.cards.face.emplacement')}}
          <span class="has-text-primary">
            {{faces[0].materiel.dispositif.emplacement.code}}
          </span>
        </p>
        <p class="has-text-default has-text-weight-semibold">
          {{$t('cartographie.cards.face.faces')}}:
            {{faces.map(f => f.code).join(', ')}}
        </p>
        <p
          v-if="faces.length === 1 && mark && mark.reseau"
          class="has-text-default has-text-weight-semibold">
          {{$t('cartographie.cards.face.reseau')}}:
            {{mark.reseau}}
        </p>
      </div>
      <div class="level-right">
        <qd-button
        :type="streetView ? '' : 'is-primary'"
        @click="toggleStreetView">
          {{streetView ?
            $t('cartographie.cards.face.retour')
            : $t('cartographie.cards.face.streetView')}}
        </qd-button>
      </div>
    </div>
    <div class="columns" v-if="!streetView">
      <div class="column is-4 pd-10px">
        <img class="width-100percent" v-if="logo" :src="logo">
      </div>
      <div class="coulmn is-8 pdh-10px width-100percent">
        <p class="is-size-4 has-text-default has-text-weight-semibold mgb-20px">
          {{$t('cartographie.cards.face.informations')}}
        </p>
        <div class="columns">
          <div class="column is-6">
            <div class="mgb-20px">
              <p class="has-text-default is-italic">
                {{$t('cartographie.cards.face.adresseCommerciale')}}
              </p>
              <p class="has-text-default has-text-weight-semibold">
                {{adresse.intitule1}}
                {{adresse.intitule2}}
                {{adresse.intitule3}}
                <br v-if="adresse.intitule1">
                {{adresse.adresse1}}
                {{adresse.adresse2}}
                {{adresse.adresse3}}
                <br v-if="adresse.adresse1">
                {{adresse.codePostal}}
                {{adresse.ville}}
                {{adresse.pays}}
              </p>
            </div>
            <div class="mgb-20px">
              <p class="has-text-default is-italic">
                {{$t('cartographie.cards.face.format')}}
              </p>
              <p class="has-text-default has-text-weight-semibold">
                {{produitFace.format}}
              </p>
            </div>
            <div class="mgb-20px">
              <p class="has-text-default is-italic">
                {{$t('cartographie.cards.face.materiel')}}
              </p>
              <p class="has-text-default has-text-weight-semibold">
                {{produitFace.materielType}}
              </p>
            </div>
            <div class="mgb-20px">
              <p class="has-text-default is-italic">
                {{$t('cartographie.cards.face.restrictions')}}
              </p>
              <p class="has-text-default has-text-weight-semibold">
                {{produitFace.restrictionsAffichage}}
              </p>
            </div>
          </div>
          <div class="column is-6">
            <div class="mgb-20px">
              <p class="has-text-default is-italic">
                {{$t('cartographie.cards.face.enAllantVers')}}
              </p>
              <p class="has-text-default has-text-weight-semibold">
                {{produitFace.enAllantVers}}
              </p>
            </div>
            <div class="mgb-20px">
              <p class="has-text-default is-italic">
                {{$t('cartographie.cards.face.enVenantDe')}}
              </p>
              <p class="has-text-default has-text-weight-semibold">
                {{produitFace.enVenantDe}}
              </p>
            </div>
            <div class="mgb-20px">
              <p class="has-text-default is-italic">
                {{$t('cartographie.cards.face.eclaire')}}
              </p>
              <p class="has-text-default has-text-weight-semibold">
                {{produitFace.eclaire ? $t('general.oui') : $t('general.non')}}
              </p>
            </div>
            <div class="mgb-20px">
              <p class="has-text-default is-italic">
                {{$t('cartographie.cards.face.affectation')}}
              </p>
              <p class="has-text-default has-text-weight-semibold">
                <info-affectations :row="produit"
                  :affectations="produit.affectations"
                  :faceMotifNonComId="produitFace.faceMotifNonComId"
                  :isFromLigneFace="false">
                </info-affectations>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mgt-40px" v-if="faces && faces.length > 1 && !streetView">
      <v-client-table
        :data="faces"
        :columns="columns"
        :options="options">
        <template v-slot:proposableLc="{ row }">
          {{ row.proposableLc ? $t('general.oui') : $t('general.non') }}
        </template>
        <template v-slot:proposableReseau="{ row }">
          {{ row.proposableReseau ? $t('general.oui') : $t('general.non') }}
        </template>
      </v-client-table>
    </div>
    <street-view-panorama
      v-if="streetView"
      style="width: 100%; height: 500px;"
      :position="this.mark.position"/>
  </div>
</template>

<script>
import {
  NO_PAGINATION, NO_PER_PAGE_VALUE, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import { getAll as getAllFaces } from '@/api/gabed/face';
import messageErreur from '@/services/general/messageErreur';
import getLogo from '@/services/general/getLogo';
import cloneDeep from 'lodash/cloneDeep';
import { components } from 'gmap-vue';
import infoAffectations from '@/components/general/infoAffectations';

export default {
  props: {
    mark: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      faces: null,
      logo: null,
      streetView: false,
    };
  },
  components: {
    StreetViewPanorama: components.StreetViewPanorama,
    infoAffectations,
  },
  computed: {
    listProduit() {
      return this.mark.type === 'produitFaces' ? [this.mark.produitId] : [this.mark.faces];
    },
    adresse() {
      return this.produitFace?.adresse ?? {};
    },
    produitFace() {
      return this.mark?.produit?.produitFace;
    },
    produit() {
      return this.mark?.produit;
    },
    columns() {
      return ['code', 'etat', 'proposableLc', 'proposableReseau'];
    },
    options() {
      const texts = cloneDeep(TEXTS);
      return {
        sortIcon: SORT_ICON,
        headings: {
          code: this.$t('cartographie.cards.face.tab.code'),
          etat: this.$t('cartographie.cards.face.tab.etat'),
          proposableLc: this.$t('cartographie.cards.face.tab.proposableLc'),
          proposableReseau: this.$t('cartographie.cards.face.tab.proposableReseau'),
        },
        sortable: [],
        texts: texts,
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: NO_PAGINATION,
      };
    },
  },
  methods: {
    toggleStreetView() {
      this.streetView = !this.streetView;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.mark.type === 'materiels') {
        this.faces = this.mark.faces;
      } else {
        this.faces = (await getAllFaces({
          limit: NO_PAGINATION,
          query: {
            produitIds: [this.mark.produitId],
            societeId: this.mark.societeId,
          },
        })).data.result.items;
      }
      this.logo = await getLogo(this.faces[0].materielId);
    } catch (e) {
      messageErreur(this.$i18n);
    } finally {
      loadingComponent.close();
    }
  },
};
</script>

<style>

</style>
